// FILE: src/components/shell/NewVersionBanner.jsx
// Top-of-page notice when a newer build has been deployed
// (src/services/appVersion.js). Polite and non-blocking: a status region
// (announced, not interrupting), icon + words, a Reload button with the
// theme's visible focus ring. The student chooses when to reload.
import React, { useEffect, useSyncExternalStore } from "react";
import { Alert, Box, Button } from "@mui/material";
import SystemUpdateAltOutlinedIcon from "@mui/icons-material/SystemUpdateAltOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getVersionState, subscribe, watchVersion } from "../../services/appVersion";

export function reloadPage() {
  window.location.reload();
}

export default function NewVersionBanner() {
  useEffect(() => watchVersion(), []);
  const { updateAvailable } = useSyncExternalStore(subscribe, getVersionState, getVersionState);

  return (
    // The live region is always there so the message is announced when it appears.
    <Box role="status" data-testid="new-version">
      {updateAvailable && (
        <Alert
          role={null}
          severity="info"
          icon={<SystemUpdateAltOutlinedIcon />}
          sx={{ borderRadius: 0, alignItems: "center", px: { xs: 2, sm: 3 } }}
          action={
            <Button variant="outlined" color="inherit" startIcon={<RefreshIcon />} onClick={() => reloadPage()}>
              Reload
            </Button>
          }
        >
          A new version of Zun Drivers is available. Reload the page when you're ready.
        </Alert>
      )}
    </Box>
  );
}
